<div class="login">
  <aside class="login-brand">
    <a class="login-logo" [href]="siteUrl" aria-label="0account website">
      <img src="assets/images/icons/0account-logo-dark.svg" alt="0account" />
    </a>
    <div class="login-brand-body">
      <p class="login-kicker">Developer console</p>
      <h2 class="login-headline">Streamline security &amp; account management</h2>
      <p class="login-lede">Manage the apps that sign users in with 0account, your plan and your usage in one place.</p>
    </div>
    <div class="login-brand-foot">© {{ year }} Oila GmbH</div>
  </aside>

  <main class="login-main">
    <div class="login-card">
      @if (isLoggedIn$ | async) {
        <h1 class="login-title">Welcome back</h1>
        <p class="login-text">You are already signed in.</p>
        <div class="login-actions">
          <a nz-button nzType="primary" nzSize="large" nzBlock routerLink="/apps">
            Go to my apps
            <span nz-icon nzType="arrow-right"></span>
          </a>
          <button nz-button nzType="default" nzSize="large" nzBlock (click)="logout()">Log out</button>
        </div>
      } @else {
        <h1 class="login-title">Sign in to your console</h1>
        <p class="login-text">Use your 0account to continue.</p>
        <div class="login-actions">
          <button nz-button nzType="primary" nzSize="large" nzBlock (click)="login()">
            <span nz-icon nzType="login"></span>
            Sign in with 0account
          </button>
        </div>
      }
      <a class="login-back" [href]="siteUrl">
        <span nz-icon nzType="arrow-left"></span>
        Back to the website
      </a>
    </div>
  </main>
</div>
